import { HotelFeatureItem } from 'services/SwaggerApi';

export const isGoodPlaceGroup = ({ features }: { features: HotelFeatureItem[]; }) =>
    features.length === 1 && features[0].feature_id === 'good_place';
